import React, { useState } from "react";
import axios from 'axios';
import MapAdmin from "./MapAdmin";
import OptionsAdmin from "./OptionsAdmin";
import MyAccounAdmin from "./MyAccountAdmin";   
import OrderListAdmin from "./OrderListAdmin";
import DeliveryListAdmin from "./DeliveryListAdmin";
import SearchGlobal from "./SearchGlobal";
import ResumenAdmin from "./ResumenAdmin";
import AccountingDashboard from "./AccountingDashboard";
import Location from "./Location";
import PackageScanner from "./PackageScanner";
import AdminPanel from "./AdminPanel";
import AdminChats from "./chat-leads/AdminChats";
import SalesChatDashboard from "./SalesChatDashboard";
import AdminProvinciaDeliveries from "./AdminProvinciaDeliveries";
import TorreDeControl from "./TorreDeControl";

function MainAdmin({ user_id, username, onLogout, email, phone_number, onUpdateUser }) {
    const [activeComponent, setActiveComponent] = useState('MapAdmin');
    
    

    const handleBackClick = () => {
        setActiveComponent('MapAdmin');
         
    };
    
    const handleMenuClick = () => {
        setActiveComponent('OptionsAdmin');
    };

    const handleOptionClick = (option) => {
        if (option === 'back') {
            setActiveComponent(activeComponent === 'MapAdmin' ? 'admin' : 'MapAdmin');
        } else if (option === 'MapSelectionAdmin') {
            setActiveComponent('MapSelectionAdmin');
        } else if (option === 'OrderListAdmin') {
            setActiveComponent('OrderListAdmin')
        } else if (option === 'DeliveryListAdmin') {
            setActiveComponent('DeliveryListAdmin')
        } else if (option === 'OptionsAdmin') {
            setActiveComponent('OptionsAdmin')
        } else if (option === 'admin') {
            setActiveComponent('admin')
        } else if (option === 'SearchGlobal') {
            setActiveComponent('SearchGlobal')
        } else if (option === 'ResumenAdmin') {
            setActiveComponent('ResumenAdmin')
        } else if (option === 'SalesChat') {
            setActiveComponent('SalesChat')
        } else if (option === 'ProvinciaDeliveries') {
            setActiveComponent('ProvinciaDeliveries')
        } else if (option === 'ControlTower') {
            setActiveComponent('ControlTower')
        }

        
        
        else {
            setActiveComponent('MyAccountAdmin')
            // Handle other options
            
        }
    };

    return (
        <div className="container-fluid p-0">
            {activeComponent === 'MapAdmin' && 
            <div className="map-container">
                
                    <MapAdmin setActiveComponent={setActiveComponent} handleMenuClick={handleMenuClick} onOptionClick={handleOptionClick} userId={user_id}/>
                     
            </div>
            }
            {activeComponent === 'OptionsAdmin' && 
                <OptionsAdmin username={username} onOptionClick={handleOptionClick} onBackClick={handleBackClick} onLogout={onLogout} />
            }
            {activeComponent === 'MyAccountAdmin' &&
                <MyAccounAdmin onUpdateUser={onUpdateUser} userId={user_id} username={username} phoneNumber={phone_number} email={email} onOptionClick={handleOptionClick} onBackClick={handleBackClick} />
            }
            {activeComponent === 'OrderListAdmin' &&
                <OrderListAdmin onOptionClick={handleOptionClick} onBackClick={handleBackClick} userId={user_id}/>
            }
            {activeComponent === 'DeliveryListAdmin' &&
                <DeliveryListAdmin activeComponent={activeComponent} onOptionClick={handleOptionClick} onBackClick={handleBackClick} userId={user_id}/>
            }
            {activeComponent === 'SearchGlobal' &&

                <SearchGlobal onBackClick={handleBackClick}/>
            }
            {activeComponent === 'PackageScanner' &&

                <PackageScanner onBackClick={handleBackClick} userId={user_id}/>
            }
            {activeComponent === 'Chat' &&

                <AdminPanel onBackClick={handleBackClick} userId={user_id}/>
            }
            {activeComponent === 'ResumenAdmin' &&
                <ResumenAdmin onBackClick={handleBackClick}/>    

            }
            {activeComponent === 'Mensajeria' &&
                <AccountingDashboard userId={user_id} setActiveComponent={setActiveComponent}/> 

            }
            {activeComponent === 'Location' &&
                <Location onBackClick={handleBackClick} userId={user_id}/> 
            }  
            {activeComponent === 'LeadsChat' &&
                <AdminChats onBackClick={handleBackClick} userId={user_id}/> 
            } 
            {activeComponent === 'SalesChat' && <SalesChatDashboard setActiveComponent={handleBackClick}/> }  
            {activeComponent === 'ProvinciaDeliveries' && <AdminProvinciaDeliveries setActiveComponent={handleBackClick}/> }
            {activeComponent === 'ControlTower' && <TorreDeControl setActiveComponent={setActiveComponent}/> }
        </div>
    );
}

export default MainAdmin;